module.exports = __webpack_public_path__ + "static/media/23_FVCON_Transepithelial.eaa27f3a.png";